import {
    PAYMENT_TYPE_LIST_REQUEST, PAYMENT_TYPE_LIST_SUCCESS, PAYMENT_TYPE_LIST_FAIL,
    PAYMENT_TYPE_DETAILS_REQUEST, PAYMENT_TYPE_DETAILS_SUCCESS, PAYMENT_TYPE_DETAILS_FAIL, PAYMENT_TYPE_DETAILS_RESET,
    PAYMENT_TYPE_CREATE_REQUEST, PAYMENT_TYPE_CREATE_SUCCESS, PAYMENT_TYPE_CREATE_FAIL, PAYMENT_TYPE_CREATE_RESET,
    PAYMENT_TYPE_UPDATE_REQUEST, PAYMENT_TYPE_UPDATE_SUCCESS, PAYMENT_TYPE_UPDATE_FAIL, PAYMENT_TYPE_UPDATE_RESET,
    PAYMENT_TYPE_DELETE_REQUEST, PAYMENT_TYPE_DELETE_SUCCESS, PAYMENT_TYPE_DELETE_FAIL,
    USER_PAYMENT_METHOD_LIST_REQUEST, USER_PAYMENT_METHOD_LIST_SUCCESS, USER_PAYMENT_METHOD_LIST_FAIL,
    USER_PAYMENT_METHOD_ADD_REQUEST, USER_PAYMENT_METHOD_ADD_SUCCESS, USER_PAYMENT_METHOD_ADD_FAIL, USER_PAYMENT_METHOD_ADD_RESET,
    USER_PAYMENT_METHOD_DELETE_REQUEST, USER_PAYMENT_METHOD_DELETE_SUCCESS, USER_PAYMENT_METHOD_DELETE_FAIL,
} from '../constants/paymentConstants'


export const paymentTypeListReducer = (state = { paymentTypes: [] }, action) => {
    switch (action.type) {
        case PAYMENT_TYPE_LIST_REQUEST: return { loading: true, paymentTypes: [] }
        case PAYMENT_TYPE_LIST_SUCCESS: return { loading: false, paymentTypes: action.payload }
        case PAYMENT_TYPE_LIST_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const paymentTypeDetailsReducer = (state = { paymentType: {} }, action) => {
    switch (action.type) {
        case PAYMENT_TYPE_DETAILS_REQUEST: return { loading: true, paymentType: {} }
        case PAYMENT_TYPE_DETAILS_SUCCESS: return { loading: false, paymentType: action.payload }
        case PAYMENT_TYPE_DETAILS_FAIL:    return { loading: false, error: action.payload }
        case PAYMENT_TYPE_DETAILS_RESET:   return { paymentType: {} }
        default: return state
    }
}

export const paymentTypeCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case PAYMENT_TYPE_CREATE_REQUEST: return { loading: true }
        case PAYMENT_TYPE_CREATE_SUCCESS: return { loading: false, success: true, paymentType: action.payload }
        case PAYMENT_TYPE_CREATE_FAIL:    return { loading: false, error: action.payload }
        case PAYMENT_TYPE_CREATE_RESET:   return {}
        default: return state
    }
}

export const paymentTypeUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case PAYMENT_TYPE_UPDATE_REQUEST: return { loading: true }
        case PAYMENT_TYPE_UPDATE_SUCCESS: return { loading: false, success: true, paymentType: action.payload }
        case PAYMENT_TYPE_UPDATE_FAIL:    return { loading: false, error: action.payload }
        case PAYMENT_TYPE_UPDATE_RESET:   return {}
        default: return state
    }
}

export const paymentTypeDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case PAYMENT_TYPE_DELETE_REQUEST: return { loading: true }
        case PAYMENT_TYPE_DELETE_SUCCESS: return { loading: false, success: true }
        case PAYMENT_TYPE_DELETE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const userPaymentMethodListReducer = (state = { methods: [] }, action) => {
    switch (action.type) {
        case USER_PAYMENT_METHOD_LIST_REQUEST: return { loading: true, methods: [] }
        case USER_PAYMENT_METHOD_LIST_SUCCESS: return { loading: false, methods: action.payload }
        case USER_PAYMENT_METHOD_LIST_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const userPaymentMethodAddReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_PAYMENT_METHOD_ADD_REQUEST: return { loading: true }
        case USER_PAYMENT_METHOD_ADD_SUCCESS: return { loading: false, success: true, method: action.payload }
        case USER_PAYMENT_METHOD_ADD_FAIL:    return { loading: false, error: action.payload }
        case USER_PAYMENT_METHOD_ADD_RESET:   return {}
        default: return state
    }
}

export const userPaymentMethodDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_PAYMENT_METHOD_DELETE_REQUEST: return { loading: true }
        case USER_PAYMENT_METHOD_DELETE_SUCCESS: return { loading: false, success: true, deletedId: action.payload }
        case USER_PAYMENT_METHOD_DELETE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}
